export default "__VITE_ASSET__BXtrulBF__"